import {
  useQuery,
  useMutation,
  useQueryClient,
  UseMutationResult,
  UseQueryResult
} from 'react-query'
import {
  fetchReviewOrder,
  createReviewOrder,
  updateReviewOrderQuantity,
  updateReviewOrderVault,
  createMarketTransaction,
  ReviewOrder
} from 'api/trading'

export function useReviewOrder(id: number | null): UseQueryResult<ReviewOrder> {
  return useQuery(['review-order', id], () => fetchReviewOrder(id as number), {
    staleTime: 0,
    enabled: id !== null
  })
}

export function useMutateCreateReviewOrder(): UseMutationResult<
  ReviewOrder,
  unknown,
  { productId: number; orderType: 'buy' | 'sell'; quantityMg: number }
> {
  return useMutation(createReviewOrder)
}

export function useMutateUpdateReviewOrderQuantity(): UseMutationResult<
  ReviewOrder,
  unknown,
  { id: number; quantityMg: number }
> {
  const qc = useQueryClient()
  return useMutation(
    ({ id, quantityMg }: { id: number; quantityMg: number }) =>
      updateReviewOrderQuantity(id, quantityMg),
    {
      onSuccess: (data, { id }) => {
        qc.invalidateQueries(['review-order', id])
        qc.invalidateQueries(['wallet'])
      }
    }
  )
}

export function useMutateUpdateReviewOrderVault(): UseMutationResult<
  ReviewOrder,
  unknown,
  { id: number; vaultId: number }
> {
  const qc = useQueryClient()
  return useMutation(
    ({ id, vaultId }: { id: number; vaultId: number }) =>
      updateReviewOrderVault(id, vaultId),
    {
      onSuccess: (data, { id }) => {
        qc.invalidateQueries(['review-order', id])
      }
    }
  )
}

export function useMutateCreateMarketTransaction(): UseMutationResult<
  { buyOrderId?: number; sellOrderId?: number },
  unknown,
  number
> {
  const qc = useQueryClient()
  return useMutation(createMarketTransaction, {
    onSuccess: () => {
      qc.invalidateQueries(['wallet'])
      qc.invalidateQueries(['securities-owned'])
      qc.invalidateQueries(['product-performance'])
      qc.invalidateQueries(['performance-summaries'])
      qc.invalidateQueries(['review-order'])
    }
  })
}
